import * as React from 'react';
import { Button, IButtonProps } from './Button';
import { Classes } from '../index';
import classNames from 'classnames';
type NavbarProps = Omit<IButtonProps, 'danger' | 'inverse' | 'style'> & {
  active?: boolean;
};

export const ToolButton: React.FC<NavbarProps> = ({
  children,
  className,
  active,
  ...props
}) => {
  return (
    <Button
      {...props}
      style={'none'}
      className={classNames(className, Classes.BUTTON_TOOL, {
        [Classes.BUTTON_TOOL_ACTIVE]: active,
      })}
      noFocus
    >
      {children}
    </Button>
  );
};
